import {
  closeSubMenuPc,
  openSubMenuPc,
  toggleInitMobile,
  toggleInitPc,
  toggleMenuMobile,
  toggleSearch,
} from './toggle'
import { initTransitionMobile, initTransitionPc } from './transition'

const searchBg = document.querySelector('.search-bg')
const jsMenu = document.querySelector('.js-menu')
const jsSearch = document.querySelector('.js-search')
const jsMenuItems = document.querySelectorAll('.js-menuItem')
const search = document.querySelector('.search')
const main = document.querySelector('.main')
const footer = document.querySelector('.footer')
export const breakPoint = window.matchMedia('(min-width: 1025px)')

export const mediaQuery = (container) => {
  const changeBreakPoint = (e) => {
    if (e.matches) {
      // pc

      /**
       * init transition
       */
      initTransitionPc()

      /**
       * menu
       */
      toggleInitPc()
      jsMenuItems.forEach((jsMenuItem) => {
        jsMenuItem.addEventListener('click', openSubMenuPc)
      })
      search.addEventListener('click', closeSubMenuPc)
      main.addEventListener('click', closeSubMenuPc)
      footer.addEventListener('click', closeSubMenuPc)
      if (container != null) container.addEventListener('click', closeSubMenuPc)
    } else {
      // mobile

      /**
       * init transition
       */
      initTransitionMobile()

      /**
       * menu
       */
      toggleInitMobile()
      jsMenu.addEventListener('click', toggleMenuMobile)
      jsSearch.addEventListener('click', toggleSearch)
      searchBg.addEventListener('click', toggleSearch)
    }
  }
  changeBreakPoint(breakPoint)
  breakPoint.addListener(changeBreakPoint)
}
